// Frontend Jalali helpers — thin wrapper over jalaali-js so the calendar logic
// matches the backend exactly.
import jalaali from 'jalaali-js';
export const gregorianToJalali = (gy, gm, gd) => jalaali.toJalaali(gy, gm, gd);
export const todayJalali = () => {
    const now = new Date();
    const { jy, jm, jd } = jalaali.toJalaali(now.getFullYear(), now.getMonth() + 1, now.getDate());
    return `${jy}-${String(jm).padStart(2, '0')}-${String(jd).padStart(2, '0')}`;
};
const PERSIAN_DIGITS = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
export const toPersianDigits = (s) => String(s).replace(/\d/g, (d) => PERSIAN_DIGITS[Number(d)]);
export const formatToman = (n) => toPersianDigits(n.toLocaleString('en-US')) + ' تومان';
const PERSIAN_WEEKDAYS = ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه', 'شنبه'];
// Above is indexed by JS getDay(): 0=Sunday … 6=Saturday — Persian week ends on Friday,
// starts on Saturday, so we look up by `(getDay())` directly.
// JS getDay: 0=Sun 1=Mon 2=Tue 3=Wed 4=Thu 5=Fri 6=Sat
// Persian: 0=Sun→یکشنبه, 1=Mon→دوشنبه, 2=Tue→سه‌شنبه, 3=Wed→چهارشنبه,
//          4=Thu→پنج‌شنبه, 5=Fri→جمعه, 6=Sat→شنبه
export const jalaliWeekday = (jalaliYmd) => {
    const [jy, jm, jd] = jalaliYmd.split('-').map(Number);
    const { gy, gm, gd } = jalaali.toGregorian(jy, jm, jd);
    const dow = new Date(Date.UTC(gy, gm - 1, gd)).getUTCDay();
    return PERSIAN_WEEKDAYS[dow];
};
export const formatJalaliWithWeekday = (jalaliYmd) => `${jalaliWeekday(jalaliYmd)} ${toPersianDigits(jalaliYmd.replaceAll('-', '/'))}`;
